import {axiosGet} from '@/api/index.js'
import {TEMPLATE_REPLECT, TEMPLATE_VISTEL, TEMPLATE_COLOR_THEME, TEMPLATE_ZHONG_SHAN, TEMPLATE_COLOR_THEME_GUIDE, TEMPLATE_LI_YAN_KE} from '@/utils/constant'

const colortheme = {
  state: {
    theme: '',
    fontColor: '',
    iconColor: '',
    bannerColorStart:'',
    bannerColorEnd: '',
  },
  mutations: {
    SET_THEME: (state, theme) => {
      state.theme = theme;
    },
    SET_FONT_COLOR: (state, fontColor) => {
      state.fontColor = fontColor;
    },
    SET_ICON_COLOR: (state, iconColor) => {
      state.iconColor = iconColor;
    },
    SET_BANNER_COLOR_START: (state, bannerColorStart) => {
      state.bannerColorStart = bannerColorStart;
    },
    SET_BANNER_COLOR_END: (state, bannerColorEnd) => {
      state.bannerColorEnd = bannerColorEnd;
    }
  },
  actions: {
    // 获取主题及颜色
    getTheme({state, commit}, orgUid){
      if (state.theme) {
        return  {theme: state.theme}
      }
      if (orgUid === 'zhongshan') {
        return  {theme: TEMPLATE_ZHONG_SHAN}
      }
      let url = 'organization/' + orgUid;
      return axiosGet({
        url
      }).then(res => {
        if (res.data.status === '200') {
          let data = res.data.data || {};
          // 如果没有配置模板，默认为vistel通用模板
          let theme = (data.template && TEMPLATE_REPLECT[data.template]) || TEMPLATE_VISTEL;
          commit('SET_THEME', theme);
          const color = data.themeColor
          let themeColor = (color && color.length > 3  && JSON.parse(color)) || {};
          let banner = themeColor.banner || {};
          if (theme === TEMPLATE_COLOR_THEME || theme === TEMPLATE_COLOR_THEME_GUIDE) {
            commit('SET_FONT_COLOR', themeColor.font || '#1ACC9D');
            commit('SET_ICON_COLOR', themeColor.icon || '#2BD8AA')
            commit('SET_BANNER_COLOR_START', banner.start || '#29E4B2');
            commit('SET_BANNER_COLOR_END', banner.end || '#08C693');
          } else if (theme === TEMPLATE_LI_YAN_KE) {
            commit('SET_FONT_COLOR', themeColor.font || '#109B73');
            commit('SET_ICON_COLOR', themeColor.icon || '#109B73')
            commit('SET_BANNER_COLOR_START', banner.start || '#4CB590');
            commit('SET_BANNER_COLOR_END', banner.end || '#109B73');
          }
          return {theme}
        } else {
          console.log('error: ' + JSON.stringify(res.data))
          return {theme: 'error'}
        }
      }).catch(err => {
        console.log('err',err);
        return {theme: 'error'}
      })
    }
  }
}

export default colortheme;




// WEBPACK FOOTER //
// ./src/store/module/colortheme.js